export default "__VITE_ASSET__DaPeOis8__"